export const reducerTypes = {
  SET_SELECTED_LANGUAGE: 'reducer/SET_SELECTED_LANGUAGE',
};
